module.exports = __webpack_public_path__ + "media/audio80.1a379860.mp3";